'use client'

import React, { ReactNode } from 'react'
import { getBugsnagClient } from '@/libs/bugsnag/bugsnag'

type ReactPluginType = {
  createErrorBoundary: (react: typeof React, opts?: unknown) => React.ComponentType<{ children: ReactNode }>
}

export type ErrorBoundaryProps = {
  children: ReactNode
}

const ErrorBoundary: React.ComponentType<ErrorBoundaryProps> = ({ children }) => {
  const reactPlugin = getBugsnagClient()?.getPlugin('react') as ReactPluginType | undefined

  const Fallback: React.ComponentType<{ children: ReactNode }> = ({ children }: { children: ReactNode }) => children

  const BugsnagErrorBoundary: React.ComponentType<{ children: ReactNode }> =
    reactPlugin?.createErrorBoundary(React) ?? Fallback

  return <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>
}

export default ErrorBoundary
